"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleCurrency = exports.handleMileage = exports.handleMask = exports.insert = void 0;
var _commonRegex = require("../commonRegex");
var insert = function insert(str, index, value) {
  return str.substr(0, index) + value + str.substr(index);
};
exports.insert = insert;
var handleMask = function handleMask(value) {
  var inputValue = value;
  if (inputValue.indexOf('.') > -1) {
    return inputValue;
  }
  if (value.indexOf(',') > -1) {
    inputValue = value.split(',').join('');
  }
  var length = inputValue.length;
  var mask = inputValue;
  while (length > 3) {
    mask = insert(mask, inputValue.length - 3, ',');
    length = inputValue.length - 3;
    inputValue = mask.substr(0, length);
  }
  if (mask.length === 0) {
    return value;
  }
  return mask;
};
exports.handleMask = handleMask;
var handleMileage = function handleMileage(value) {
  if (typeof value === 'undefined') {
    return;
  }
  if (!_commonRegex.Mileage.test(value)) {
    return null;
  }
  var mask = handleMask(value);
  return mask;
};
exports.handleMileage = handleMileage;
var handleCurrency = function handleCurrency(value) {
  if (typeof value === 'undefined') {
    return;
  }
  if (!_commonRegex.Currency.test(value)) {
    return null;
  }
  var mask = '';
  mask = "".concat(handleMask(value.replace('$', '')));
  return "$".concat(mask);
};
exports.handleCurrency = handleCurrency;